import { Controller } from "@hotwired/stimulus"

// Dispatches count updates whenever the quote/cart badges re-render.
export default class extends Controller {
  static values = {
    type: String,
    count: Number
  }

  connect() {
    this.dispatchUpdate()
  }

  countValueChanged() {
    this.dispatchUpdate()
  }

  dispatchUpdate() {
    const detail = {
      type: this.typeValue,
      count: Number.isFinite(this.countValue) ? this.countValue : 0
    }

    window.dispatchEvent(
      new CustomEvent("top-notice:count-changed", { detail })
    )
  }
}
